import { parse_db_datetime } from './format'

export function escape_html(value: unknown): string {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
}

/**
 * Data absoluta a partir do `DATETIME` cru do banco.
 *
 * Usa o MESMO parser do `relative_date`. Antes, `new Date('2026-08-24 19:22:07')`
 * era interpretado como hora LOCAL do navegador: certo em Brasília, errado em
 * qualquer outro fuso — e a data mostrada dependia de onde o operador estava
 * sentado, não de quando o evento aconteceu.
 */
export function format_date(value: string | null | undefined): string {
  if (!value) return '-'
  try {
    const date = parse_db_datetime(value)
    if (Number.isNaN(date.getTime())) return String(value)
    return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).format(date)
  } catch {
    return String(value)
  }
}
